import styled from 'styled-components'

import { fontWeightMedium, media, white } from '../../../utils/style-utils'
import UrlLink from '../../UrlLink'

export const Label = styled(UrlLink)`
  font-size: 1.25rem;
  margin: 0.75rem 0;
  color: ${white};
  font-weight: ${fontWeightMedium};
  user-select: none;
  cursor: pointer;

  ${media.xs`
    font-size: 1rem;
    margin: 0.5rem 0;
  `}
`
